import { render, staticRenderFns } from "./index_h5.vue?vue&type=template&id=49198b40&scoped=true&"
import script from "./index_h5.vue?vue&type=script&lang=js&"
export * from "./index_h5.vue?vue&type=script&lang=js&"
import style0 from "./index_h5.vue?vue&type=style&index=0&id=49198b40&lang=less&scoped=true&"
import style1 from "./index_h5.vue?vue&type=style&index=1&id=49198b40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49198b40",
  null
  
)

export default component.exports